import { render, staticRenderFns } from "./InventoryVehicleCard.vue?vue&type=template&id=36160aea&scoped=true&"
import script from "./InventoryVehicleCard.vue?vue&type=script&lang=js&"
export * from "./InventoryVehicleCard.vue?vue&type=script&lang=js&"
import style0 from "./InventoryVehicleCard.vue?vue&type=style&index=0&id=36160aea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36160aea",
  null
  
)

export default component.exports